import { ErrorHandler, Injectable, Injector } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: unknown) {
    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      console.error('Backend returned status code: ', error.status)
      console.error('Response body:', error.message)
    } else {
      // Client Error happened
      const clientError = error as { message?: string } | null | undefined
      console.error('An error occurred:', clientError?.message || error)
    }

    // Always log errors
    console.error('Error stack trace:', (error as { stack?: string } | null | undefined)?.stack)

    // You might want to send the error to remote logging infrastructure
    // logError(error);

    // Re-throw the error if you want the default behavior
    // throw error;
  }
}
